import React, { useEffect, useState, useCallback } from 'react';
import api from '../services/api';

const AdminInternshipRegistrations = ({ isActive = true }) => {
  const [registrations, setRegistrations] = useState([]);
  const [programName, setProgramName] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const loadRegistrations = useCallback(async () => {
    setLoading(true);
    setMessage('');
    try {
      const res = await api.get('/api/internship/admin/registrations');
      setRegistrations(res.data?.registrations || []);
      setProgramName(res.data?.programName || 'DSA Crash Course');
      if ((res.data?.registrations || []).length === 0) {
        setMessage('ℹ️ No DSA Crash Course registrations yet. Students appear here after successful Razorpay payment.');
      }
    } catch (error) {
      console.error('Failed to load DSA Crash Course registrations:', error);
      const status = error.response?.status;
      const detail = error.response?.data?.error || error.message;
      if (status === 403) {
        setMessage('❌ Access denied. Make sure you are logged in as an admin.');
      } else if (status === 401) {
        setMessage('❌ Session expired. Please log out and log in again as admin.');
      } else {
        setMessage(`❌ Failed to load DSA Crash Course registrations (${status || 'network'}): ${detail}`);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isActive) {
      loadRegistrations();
    }
  }, [isActive, loadRegistrations]);

  const formatDate = (value) => {
    if (!value) return '—';
    return new Date(value).toLocaleString();
  };

  return (
    <div className="section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
        <div>
          <h3>💻 DSA Crash Course Registrations</h3>
          <p style={{ margin: '6px 0 0', color: '#64748b', fontSize: '14px' }}>
            {programName || 'DSA Crash Course'} · ₹100 · Paid via Razorpay
          </p>
        </div>
        <button
          onClick={loadRegistrations}
          disabled={loading}
          style={{ padding: '10px 16px', borderRadius: '8px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer' }}
        >
          {loading ? 'Loading...' : '🔄 Refresh'}
        </button>
      </div>

      {message && (
        <div style={{ margin: '12px 0', padding: '12px', borderRadius: '8px', background: message.startsWith('❌') ? '#fef2f2' : '#f0f9ff', color: message.startsWith('❌') ? '#b91c1c' : '#0369a1' }}>
          {message}
        </div>
      )}

      {!loading && registrations.length > 0 && (
        <>
          <div style={{ margin: '16px 0', fontWeight: 700, color: '#0f172a' }}>
            Total registrations: {registrations.length}
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
              <thead>
                <tr style={{ background: '#f8fafc', textAlign: 'left' }}>
                  <th style={{ padding: '10px', borderBottom: '1px solid #e2e8f0' }}>#</th>
                  <th style={{ padding: '10px', borderBottom: '1px solid #e2e8f0' }}>Student</th>
                  <th style={{ padding: '10px', borderBottom: '1px solid #e2e8f0' }}>Email</th>
                  <th style={{ padding: '10px', borderBottom: '1px solid #e2e8f0' }}>Phone</th>
                  <th style={{ padding: '10px', borderBottom: '1px solid #e2e8f0' }}>Amount</th>
                  <th style={{ padding: '10px', borderBottom: '1px solid #e2e8f0' }}>Payment ID</th>
                  <th style={{ padding: '10px', borderBottom: '1px solid #e2e8f0' }}>Registered At</th>
                </tr>
              </thead>
              <tbody>
                {registrations.map((reg, index) => (
                  <tr key={reg.id}>
                    <td style={{ padding: '10px', borderBottom: '1px solid #f1f5f9' }}>{index + 1}</td>
                    <td style={{ padding: '10px', borderBottom: '1px solid #f1f5f9' }}>
                      <div style={{ fontWeight: 600 }}>{reg.username || '—'}</div>
                      <div style={{ color: '#64748b', fontSize: '12px' }}>User ID: {reg.userId ?? '—'}</div>
                    </td>
                    <td style={{ padding: '10px', borderBottom: '1px solid #f1f5f9' }}>{reg.email || '—'}</td>
                    <td style={{ padding: '10px', borderBottom: '1px solid #f1f5f9' }}>{reg.phoneNumber || '—'}</td>
                    <td style={{ padding: '10px', borderBottom: '1px solid #f1f5f9' }}>
                      {reg.amount != null ? `₹${reg.amount}` : '—'}
                    </td>
                    <td style={{ padding: '10px', borderBottom: '1px solid #f1f5f9', fontFamily: 'monospace', fontSize: '12px' }}>
                      {reg.paymentId || '—'}
                    </td>
                    <td style={{ padding: '10px', borderBottom: '1px solid #f1f5f9' }}>{formatDate(reg.registeredAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminInternshipRegistrations;
